import { put } from 'redux-saga/effects';

import axios from '../../api/axios';
import * as actions from '../actions/index';
import { URL_CONFIG } from '../../shared/config/index';

export function* reportIssueSaga(action) {
    yield put(actions.reportIssueStart());
    try {
        const res = yield axios.post(URL_CONFIG.emailApi, action.data);
        if (res && res.data && res.data.statusCode === 200) {
            yield put(actions.reportIssueSuccess(res.data['message']));
        } else {
            throw (res.data ? res.data : res);
        }
    } catch (err) {
        yield put(actions.reportIssueFail(err.message));
    }
}